const sonarrBlue = '#35c5f4';
const darkGray = '#888';
const mediumGray = '#999';
const gray = '#adadad';
const black = '#000';
const white = '#fff';
const offWhite = '#f5f7fa';
const purple = '#7a43b6';
const pink = '#ff69b4';
const lightGray = '#ddd';

module.exports = {
  textColor: '#ccc',
  defaultColor: '#ccc',
  disabledColor: '#999',
  dimColor: '#555',
  black,
  white,
  offWhite,
  primaryColor: '#5d9cec',
  selectedColor: '#f9be03',
  successColor: '#00853d',
  dangerColor: '#f05050',
  warningColor: '#ffa500',
  infoColor: '#5d9cec',
  purple,
  pink,
  sonarrBlue,
  helpTextColor: '#909293',
  darkGray,
  gray,
  lightGray,
  mediumGray,

  // Theme Colors

  themeBlue: sonarrBlue,
  themeAlternateBlue: '#2193b5',
  themeRed: '#c4273c',
  themeDarkColor: '#494949',
  themeLightColor: '#595959',
  pageBackground: '#202020',
  pageFooterBackground: 'rgba(0, 0, 0, .25)',

  torrentColor: '#00853d',
  usenetColor: '#17b1d9',

  // Labels
  inverseLabelColor: '#ddd',
  inverseLabelTextColor: '#333',
  disabledLabelColor: '#838383',
  infoTextColor: white,

  // Links
  defaultLinkHoverColor: '#fff',
  linkColor: '#5d9cec',
  linkHoverColor: '#1b72e2',

  // Header
  pageHeaderBackgroundColor: '#2a2a2a',

  // Sidebar

  sidebarColor: '#e1e2e3',
  sidebarBackgroundColor: '#2a2a2a',
  sidebarActiveBackgroundColor: '#333333',

  // Toolbar
  toolbarColor: '#e1e2e3',
  toolbarBackgroundColor: '#262626',
  toolbarMenuItemBackgroundColor: '#333',
  toolbarMenuItemHoverBackgroundColor: '#414141',
  toolbarLabelColor: '#e1e2e3',

  // Accents
  borderColor: '#858585',
  inputBorderColor: '#dde6e9',
  inputBoxShadowColor: 'rgba(0, 0, 0, 0.075)',
  inputFocusBorderColor: '#66afe9',
  inputFocusBoxShadowColor: 'rgba(102, 175, 233, 0.6)',
  inputErrorBorderColor: '#f05050',
  inputErrorBoxShadowColor: 'rgba(240, 80, 80, 0.6)',
  inputWarningBorderColor: '#ffa500',
  inputWarningBoxShadowColor: 'rgba(255, 165, 0, 0.6)',
  colorImpairedGradient: '#707070',
  colorImpairedGradientDark: '#424242',
  colorImpairedDangerGradient: '#d84848',
  colorImpairedWarningGradient: '#e59400',
  colorImpairedPrimaryGradient: '#538cd4',
  colorImpairedGrayGradient: '#9b9b9b',

  //
  // Buttons

  defaultButtonTextColor: '#eee',
  defaultBackgroundColor: '#333',
  defaultBorderColor: '#393f45',
  defaultHoverBackgroundColor: '#444',
  defaultHoverBorderColor: '#5a6265',

  primaryBackgroundColor: '#5d9cec',
  primaryBorderColor: '#5899eb',
  primaryHoverBackgroundColor: '#4b91ea',
  primaryHoverBorderColor: '#3483e7',

  successBackgroundColor: '#27c24c',
  successBorderColor: '#26be4a',
  successHoverBackgroundColor: '#24b145',
  successHoverBorderColor: '#1f9c3d',

  warningBackgroundColor: '#ff902b',
  warningBorderColor: '#ff8d26',
  warningHoverBackgroundColor: '#ff8517',
  warningHoverBorderColor: '#fc7800',

  dangerBackgroundColor: '#f05050',
  dangerBorderColor: '#f04b4b',
  dangerHoverBackgroundColor: '#ee3d3d',
  dangerHoverBorderColor: '#ec2626',

  iconButtonDisabledColor: '#7a7a7a',
  iconButtonHoverColor: '#666',
  iconButtonHoverLightColor: '#ccc',

  //
  // Modal

  modalBackdropBackgroundColor: 'rgba(0, 0, 0, 0.6)',
  modalBackgroundColor: '#2a2a2a',
  modalCloseButtonHoverColor: '#888',

  //
  // Menu
  menuItemColor: '#e1e2e3',
  menuItemHoverColor: sonarrBlue,
  menuItemHoverBackgroundColor: '#606060',

  //
  // Toolbar

  toobarButtonHoverColor: sonarrBlue,
  toobarButtonSelectedColor: sonarrBlue,

  //
  // Scroller

  scrollbarBackgroundColor: '#707070',
  scrollbarHoverBackgroundColor: '#606060',

  //
  // Card

  cardBackgroundColor: '#333333',
  cardShadowColor: '#111',
  cardAlternateBackgroundColor: '#333333',
  cardCenterBackgroundColor: '#2a2a2a',

  //
  // Alert

  alertDangerBorderColor: '#a94442',
  alertDangerBackgroundColor: 'rgba(255,0,0,0.1)',
  alertDangerColor: '#ccc',

  alertInfoBorderColor: '#31708f',
  alertInfoBackgroundColor: 'rgba(0,0,255,0.1)',
  alertInfoColor: '#ccc',

  alertSuccessBorderColor: '#3c763d',
  alertSuccessBackgroundColor: 'rgba(0,255,0,0.1)',
  alertSuccessColor: '#ccc',

  alertWarningBorderColor: '#8a6d3b',
  alertWarningBackgroundColor: 'rgba(255,255,0,0.1)',
  alertWarningColor: '#ccc',

  //
  // Slider

  sliderAccentColor: '#5d9cec',

  //
  // Form

  inputBackgroundColor: '#333',
  inputReadOnlyBackgroundColor: '#222',
  inputHoverBackgroundColor: 'rgba(255, 255, 255, 0.20)',
  inputSelectedBackgroundColor: 'rgba(255, 255, 255, 0.05)',
  advancedFormLabelColor: '#ff902b',
  disabledCheckInputColor: '#ddd',
  disabledInputColor: '#808080',

  //
  // Popover

  popoverTitleBackgroundColor: '#424242',
  popoverTitleBorderColor: '#2a2a2a',
  popoverBodyBackgroundColor: '#2a2a2a',
  popoverShadowColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderColor: '#2a2a2a',

  popoverTitleBackgroundInverseColor: '#595959',
  popoverTitleBorderInverseColor: '#707070',
  popoverShadowInverseColor: 'rgba(0, 0, 0, 0.2)',
  popoverArrowBorderInverseColor: 'rgba(58, 63, 81, 0.75)',

  //
  // Calendar

  calendarTodayBackgroundColor: '#3e3e3e',
  calendarBackgroundColor: '#2a2a2a',
  calendarBorderColor: '#393f45',
  calendarTextDim: '#eee',
  calendarTextDimAlternate: '#fff',

  calendarFullColorFilter: 'grayscale(90%) contrast(200%) saturate(50%)',

  //
  // Table

  tableRowHoverBackgroundColor: 'rgba(255, 255, 255, 0.08)',

  //
  // Series

  addSeriesBackgroundColor: '#2a2a2a',
  seriesBackgroundColor: '#2a2a2a',
  searchIconContainerBackgroundColor: '#2b2b2b',
  collapseButtonBackgroundColor: '#2a2a2a',

  //
  // Season

  seasonBackgroundColor: '#424242',
  episodesBackgroundColor: '#2a2a2a',

  //
  // misc

  progressBarFrontTextColor: white,
  progressBarBackTextColor: white,
  progressBarBackgroundColor: '#727070',
  logEventsBackgroundColor: '#2a2a2a'
};
